import { RulebookStatus, RulebookVisibility } from "@next-platform/packages-ts-types";
import parseRulebookMeterChips from "../parseRulebookMeterChips";
import { RulebookSelectionSort } from "./rulebookSelection";
/** Maps an index hit to the summary the picker and form already use, so a public pick flows through the same path. */
export function mapRulebookHit(hit) {
    return {
        id: hit.rulebook_id ?? hit.id ?? "",
        name: hit.name ?? "",
        description: hit.description ?? "",
        tags: hit.tags ?? [],
        cover_url: hit.cover_url,
        visibility: hit.visibility ?? RulebookVisibility.PUBLIC,
        ...(hit.definition_visible !== undefined && { definition_visible: hit.definition_visible }),
        // Only approved, servable Rulebooks are indexed.
        status: RulebookStatus.ACTIVE,
        version: 0,
        num_meters: hit.num_meters ?? 0,
        num_rules: hit.num_rules ?? 0,
        num_hidden_meters: hit.num_hidden_meters ?? 0,
        meter_chips: parseRulebookMeterChips(hit.meter_chips),
        num_attached_characters: hit.num_attached_characters ?? 0,
        num_attached_personas: hit.num_attached_personas ?? 0,
        createdAt: hit.createdAt,
        creatorUsername: hit.creator_username,
        isCoverNsfw: Boolean(hit.cover_is_nsfw),
    };
}
/**
 * Typesense filter for the public Rulebooks of this app. The host passes its NSFW exclusion clause when the viewer
 * filters NSFW content, since the NSFW tag list is platform configuration.
 */
export function buildRulebookDiscoverFilter({ applicationId, nsfwExclusionFilter, }) {
    const clauses = [`visibility:${RulebookVisibility.PUBLIC}`];
    if (applicationId) {
        clauses.push(`application_ids:${applicationId}`);
    }
    if (nsfwExclusionFilter) {
        clauses.push(nsfwExclusionFilter);
    }
    return clauses.join(" && ");
}
/** The createdAt sort clause for a picker sort; relevance ranking stays the host's first sort key. */
export function resolveRulebookDiscoverSortBy(sort) {
    return sort === RulebookSelectionSort.Oldest ? "createdAt:asc" : "createdAt:desc";
}
